/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AorvExcelZeile } from './AorvExcelZeile';
import {
    AorvExcelZeileFromJSON,
    AorvExcelZeileFromJSONTyped,
    AorvExcelZeileToJSON,
} from './AorvExcelZeile';
import type { AorvImportEintragAnmerkung } from './AorvImportEintragAnmerkung';
import {
    AorvImportEintragAnmerkungFromJSON,
    AorvImportEintragAnmerkungFromJSONTyped,
    AorvImportEintragAnmerkungToJSON,
} from './AorvImportEintragAnmerkung';

/**
 * 
 * @export
 * @interface AorvImportEintrag
 */
export interface AorvImportEintrag {
    /**
     * 
     * @type {AorvExcelZeile}
     * @memberof AorvImportEintrag
     */
    aorvExcelZeile: AorvExcelZeile;
    /**
     * Zusatzinformationen zur Verarbeitung (z.B. Erfolg oder Fehlerbeschreibungen)
     * @type {Array<AorvImportEintragAnmerkung>}
     * @memberof AorvImportEintrag
     */
    anmerkungen: Array<AorvImportEintragAnmerkung>;
}

/**
 * Check if a given object implements the AorvImportEintrag interface.
 */
export function instanceOfAorvImportEintrag(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "aorvExcelZeile" in value;
    isInstance = isInstance && "anmerkungen" in value;

    return isInstance;
}

export function AorvImportEintragFromJSON(json: any): AorvImportEintrag {
    return AorvImportEintragFromJSONTyped(json, false);
}

export function AorvImportEintragFromJSONTyped(json: any, ignoreDiscriminator: boolean): AorvImportEintrag {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'aorvExcelZeile': AorvExcelZeileFromJSON(json['aorvExcelZeile']),
        'anmerkungen': ((json['anmerkungen'] as Array<any>).map(AorvImportEintragAnmerkungFromJSON)),
    };
}

export function AorvImportEintragToJSON(value?: AorvImportEintrag | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'aorvExcelZeile': AorvExcelZeileToJSON(value.aorvExcelZeile),
        'anmerkungen': ((value.anmerkungen as Array<any>).map(AorvImportEintragAnmerkungToJSON)),
    };
}

